import React, { useState } from "react";


export const TruncatedText = ({ text = "", maxLength = 50 }) => {
    const [showFull, setShowFull] = useState(false);
    if (text.length <= maxLength) return <span>{text}</span>;
    return (
        <span>
            {showFull ? text : `${text.substring(0, maxLength)}... `}
            <a
                href=""
                onClick={(e) => { e.preventDefault(); setShowFull(!showFull); }}
                style={{ color: '#007bff', cursor: 'pointer' }}
            >
                {showFull ? 'See less' : 'See more'}
            </a>
        </span>
    );
};


export const CleanNumber = (value) => {
    return value.replace(/[^\d]/g, '');
};